<template>
    <div class="tours">
        <div class="top">
            <!-- <img src="../../assets/imgs/tours-bg.png" alt=""> -->
            <div class="title">TravelProduct</div>
        </div>
        <div class="breadcrumb">
            <el-breadcrumb :separator-icon="ArrowRight">
                <el-breadcrumb-item :to="{ path: '/tours' }">Tours</el-breadcrumb-item>
                <el-breadcrumb-item>2025 (純玩)廈門武夷山鼓浪嶼泉州6天</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="staff">
            <div class="title">2025 (純玩)廈門武夷山鼓浪嶼泉州6天</div>
            <el-tabs v-model="activeName" type="card" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane label="Description" name="first">
                    <div class="staff-con">
                        <div class="img">
                            <el-image style="width: 100%; height: 600px"
                                src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/2025-%E7%B4%94%E7%8E%A9%E5%8E%A6%E9%97%A8%E6%AD%A6%E5%A4%B7%E5%B1%B1%E9%BC%93%E6%B5%AA%E5%B1%BF%E6%B3%89%E5%B7%9E6%E5%A4%A9AUD_001-1117x1536.jpg"
                                :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                                :preview-src-list="['https://www.youngtravel.com.au/wp-content/uploads/2025/05/2025-%E7%B4%94%E7%8E%A9%E5%8E%A6%E9%97%A8%E6%AD%A6%E5%A4%B7%E5%B1%B1%E9%BC%93%E6%B5%AA%E5%B1%BF%E6%B3%89%E5%B7%9E6%E5%A4%A9AUD_001-1117x1536.jpg']"
                                :initial-index="4" fit="cover" />
                        </div>
                        <div class="con" v-html="editorHtml"></div>
                    </div>

                </el-tab-pane>
                <el-tab-pane label="Reviews" name="second">
                    <div class="staff-con">
                        <div class="form">
                            <div class="form-title">Reviews</div>
                            <el-form ref="ruleFormRef" label-position="top" :model="ruleForm" :rules="rules"
                                label-width="auto" class="demo-ruleForm" :size="formSize" status-icon>
                                <el-form-item label="rating" prop="name">
                                    <el-rate v-model="ruleForm.value" :max="5" size="large" />
                                </el-form-item>
                                <el-form-item label="review" prop="name">
                                    <el-input v-model="ruleForm.name" placeholder="please enter your review" />
                                </el-form-item>
                                <el-form-item label="name" prop="name">
                                    <el-input v-model="ruleForm.name" placeholder="please enter your name" />
                                </el-form-item>
                                <el-form-item label="email" prop="name">
                                    <el-input v-model="ruleForm.name" placeholder="please enter your email" />
                                </el-form-item>
                                <el-form-item>
                                    <el-checkbox v-model="ruleForm.checked"
                                        label="Save my name, email, and website in this browser for the next time I comment." />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="submitForm(ruleFormRef)">
                                        Create
                                    </el-button>
                                    <el-button @click="resetForm(ruleFormRef)">Reset</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="travel-title">Related products</div>
        <div class="travel-lists">
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/%E5%87%B1%E6%81%A9%E6%96%AF-%E5%86%92%E9%9A%AA%E8%99%9F-20250317-s-1536x867.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    【中文团】凯恩斯3/4日精华游 （可選包含酒店或不包含酒店）Cairns 4 day essence tour (Optional to include hotel or not include
                    hotel)
                </div>
                <div class="btn">Read More</div>
            </div>
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/%E5%A2%A8%E7%88%BE%E6%9C%AC5%E6%97%A5%E9%81%8A-S-scaled.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    【中文团】墨尔本5日游 Mandarin Tour – Melbourne 5 Days Tour
                </div>
                <div class="btn">Read More</div>
            </div>
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/2025-%E7%B4%94%E7%8E%A9%E5%8E%A6%E9%97%A8%E6%AD%A6%E5%A4%B7%E5%B1%B1%E9%BC%93%E6%B5%AA%E5%B1%BF%E6%B3%89%E5%B7%9E6%E5%A4%A9AUD_001-1117x1536.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    2025 (純玩)廈門武夷山鼓浪嶼泉州6天
                </div>
                <div class="btn">Read More</div>
            </div>
            <div class="list" @click="toDetailFn">
                <div class="img">
                    <img src="https://www.youngtravel.com.au/wp-content/uploads/2025/05/2025-%E7%B4%94%E7%8E%A9%E6%88%90%E9%83%BD%E4%B8%89%E6%98%9F%E5%A0%86%E7%86%8A%E7%8C%AB%E5%9F%BA%E5%9C%B0-6%E5%A4%A9AUD_001-600x825.jpg"
                        alt="">
                </div>
                <div class="title u-line-2">
                    2025 (純玩)成都三星堆熊猫基地 6天
                </div>
                <div class="btn">Read More</div>
            </div>
        </div>
    </div>
</template>

<!-- <script setup lang="ts">
import { reactive, ref } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const editorHtml = ref(`
        <h3>交通行程</h3>
        <br/>
        此产品需自行订机票，并告知航班，安排接送机。
        <br/><br/>
        <h4>注意事项</h4>
        儿童价适用年龄12岁以下儿童，婴儿适用未满3岁。<br/>
        早上8点和晚9点之间的航班都可以，不在这个时间范围内接送机附加费$20PP<br/>
        本产品为预设内容，顾客可于订购时按需求从预设内容中选择并订制行程，订单一旦确定行程顺序不得再更改。行程中景点门票及自费项目需向导游统一购买，所有价格或景点门票以当天价格为准，如有变动恕不另行通知。<br/>
        退改政策: 请参照本站标准条款中的退改政策。<br/>
        因人数不足或天气原因，本公司有权在启程前或启程后取消或更改行程，也有权缩短或延长旅程。<br/>
        团友旅游安全由各交通公司、旅店、各旅游景点等直接负责，与本公司无关。建议各位游客购买旅行保险<br/><br/>
        <h4>[潜水须知]</h4>
        12岁以下禁止深潜。<br/>
        参加深潜无需潜水证，深潜都有专业教练带领，下潜深度6-10米。<br/>
        浮潜也会消耗一定体力。请不要超出能力范围，如曾服用药物，请告知工作人员。<br/>
        女性怀孕或例假期间不建议浮潜和深潜。<br/>
        持证潜水项目需要有潜水证才能参加，浮潜项目则不需要。<br/>
        一天单次深潜后，建议12小时内不要高空飞行。<br/><br/>
        <h4>[热带雨林行程须知]</h4>
        雨林缆车:每趟Skyrail索道观光需要约90分钟。沿途在两个中转站停留，红峰站和拜伦瀑布站。您可以下缆车近距离欣赏热带雨林风光。每个站点需时20至30分钟。雨林缆车两个站点均设有洗手间，并备有雨伞供游客免费使用。<br/>
        观光火车:整个火车旅途需要1小时45分钟。从Kuranda出发只有两班(下午2点和3点半)，请掌握好游玩时间:返回途中有一站叫清水站 (Freshwater Station)，请返回凯恩斯的游客不要在此下车。<br/>
        价格包含<br/>
        • 全程中文司机导游及机场接送机 (大堡礁一日游无导游陪同) <br/>
        • 冒险号绝代双礁一日游套餐 (往返大型空调双体船接送、自助午餐、茶和咖啡、免费浮潜用具、玻璃底船和半潜水艇船)<br/>
        • 热带雨林公园(含水陆两用车、土著文化、土著表演)<br/>
        <br/>
        (以下依购买包含) <br/>
        3日含酒店【可选2晚3.5星/4星/5星级酒店含早餐】 <br/>
        4日含酒店【可选3晚3.5星/4星/5星级酒店含早餐】<br/>
        <br/>
        价格不包含<br/>
        • 如自行安排酒店不含酒店跟早餐<br/>
        • 门票:库兰达缆车和雨林火车(行程中价格仅供参考，请以门牌为准)<br/>
        • 导游小费每人$5/天<br/>
        • 单房差<br/>
        • 其他:个人消费，重大节庆假期，学生假期酒店附加费用(需提前与op确认)<br/>
        • 往返机票以及托运行李，旅行保险，行程中注明的自费项目及未包含的其他旅费<br/>
        • 升级 Reef Magic Cruises 船去船回 成人 AUD$40 / 儿童 AUD$30
`)

import type { TabsPaneContext } from 'element-plus'
const activeName = ref('first')
const handleClick = (tab: TabsPaneContext, event: Event) => {
    console.log(tab, event)
}

import type { ComponentSize, FormInstance, FormRules } from 'element-plus'

interface RuleForm {
    name: string
    region: string
    value: number
    checked: boolean
    count: string
    date1: string
    date2: string
    delivery: boolean
    location: string
    type: string[]
    resource: string
    desc: string
}

const formSize = ref<ComponentSize>('default')
const ruleFormRef = ref<FormInstance>()
const ruleForm = reactive<RuleForm>({
    name: 'Hello',
    region: '',
    value: 0,
    checked: false,
    count: '',
    date1: '',
    date2: '',
    delivery: false,
    location: '',
    type: [],
    resource: '',
    desc: '',
})

const rules = reactive<FormRules<RuleForm>>({
    name: [
        { required: true, message: 'Please input Activity name', trigger: 'blur' },
        { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
    ],
    region: [
        {
            required: true,
            message: 'Please select Activity zone',
            trigger: 'change',
        },
    ],
})
const submitForm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {
            console.log('submit!')
        } else {
            console.log('error submit!', fields)
        }
    })
}

const resetForm = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    formEl.resetFields()
}
 
const toDetailFn = () => {
    console.log(1111111)
    router.push('/zh/toursDetail')
} 
</script> -->


<script>
export default {
  data() {
    return {
      editorHtml: `
        <h3>交通行程</h3>
        <br/>
        此产品需自行订机票，并告知航班，安排接送机。
        <br/><br/>
        <h4>注意事项</h4>
        儿童价适用年龄12岁以下儿童，婴儿适用未满3岁。<br/>
        早上8点和晚9点之间的航班都可以，不在这个时间范围内接送机附加费$20PP<br/>
        本产品为预设内容，顾客可于订购时按需求从预设内容中选择并订制行程，订单一旦确定行程顺序不得再更改。行程中景点门票及自费项目需向导游统一购买，所有价格或景点门票以当天价格为准，如有变动恕不另行通知。<br/>
        退改政策: 请参照本站标准条款中的退改政策。<br/>
        因人数不足或天气原因，本公司有权在启程前或启程后取消或更改行程，也有权缩短或延长旅程。<br/>
        团友旅游安全由各交通公司、旅店、各旅游景点等直接负责，与本公司无关。建议各位游客购买旅行保险<br/><br/>
        <h4>[潜水须知]</h4>
        12岁以下禁止深潜。<br/>
        参加深潜无需潜水证，深潜都有专业教练带领，下潜深度6-10米。<br/>
        浮潜也会消耗一定体力。请不要超出能力范围，如曾服用药物，请告知工作人员。<br/>
        女性怀孕或例假期间不建议浮潜和深潜。<br/>
        持证潜水项目需要有潜水证才能参加，浮潜项目则不需要。<br/>
        一天单次深潜后，建议12小时内不要高空飞行。<br/><br/>
        <h4>[热带雨林行程须知]</h4>
        雨林缆车:每趟Skyrail索道观光需要约90分钟。沿途在两个中转站停留，红峰站和拜伦瀑布站。您可以下缆车近距离欣赏热带雨林风光。每个站点需时20至30分钟。雨林缆车两个站点均设有洗手间，并备有雨伞供游客免费使用。<br/>
        观光火车:整个火车旅途需要1小时45分钟。从Kuranda出发只有两班(下午2点和3点半)，请掌握好游玩时间:返回途中有一站叫清水站 (Freshwater Station)，请返回凯恩斯的游客不要在此下车。<br/>
        价格包含<br/>
        • 全程中文司机导游及机场接送机 (大堡礁一日游无导游陪同) <br/>
        • 冒险号绝代双礁一日游套餐 (往返大型空调双体船接送、自助午餐、茶和咖啡、免费浮潜用具、玻璃底船和半潜水艇船)<br/>
        • 热带雨林公园(含水陆两用车、土著文化、土著表演)<br/>
        <br/>
        (以下依购买包含) <br/>
        3日含酒店【可选2晚3.5星/4星/5星级酒店含早餐】 <br/>
        4日含酒店【可选3晚3.5星/4星/5星级酒店含早餐】<br/>
        <br/>
        价格不包含<br/>
        • 如自行安排酒店不含酒店跟早餐<br/>
        • 门票:库兰达缆车和雨林火车(行程中价格仅供参考，请以门牌为准)<br/>
        • 导游小费每人$5/天<br/>
        • 单房差<br/>
        • 其他:个人消费，重大节庆假期，学生假期酒店附加费用(需提前与op确认)<br/>
        • 往返机票以及托运行李，旅行保险，行程中注明的自费项目及未包含的其他旅费<br/>
        • 升级 Reef Magic Cruises 船去船回 成人 AUD$40 / 儿童 AUD$30
      `,
      activeName: 'first',
      formSize: 'default',
      ruleForm: {
        name: 'Hello',
        region: '',
        value: 0,
        checked: false,
        count: '',
        date1: '',
        date2: '',
        delivery: false,
        location: '',
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: 'Please input Activity name', trigger: 'blur' },
          { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
        ],
        region: [
          {
            required: true,
            message: 'Please select Activity zone',
            trigger: 'change',
          },
        ],
      }
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    submitForm() {
      this.$refs.ruleFormRef.validate((valid, fields) => {
        if (valid) {
          console.log('submit!')
        } else {
          console.log('error submit!', fields)
        }
      })
    },
    resetForm() {
      this.$refs.ruleFormRef.resetFields()
    },
    toDetailFn() {
      this.$router.push('/zh/toursDetail')
    }
  }
}
</script>

<style lang="less" scoped>
.tours {
    padding-bottom: 120px;

    .top {
        width: 100vw;
        height: 650px;
        position: relative;
        overflow: hidden;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: 700;
            color: #fff;
            text-shadow: 3px 3px 5px #ec0b29;
        }

        .subtitle {
            position: absolute;
            top: 60%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            font-weight: 700;
            color: #fff;
        }


        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    .breadcrumb {
        margin: 40px auto;
        max-width: 1200px;
    }

    .staff {
        max-width: 1200px;
        margin: 0 auto;

        .title {
            font-size: 30px;
            font-weight: 700;
            margin: 80px 0;
            text-align: center;
            color: #ec0b29;
        }

        .staff-con {
            display: flex; 
            position: relative;

            .form {
                padding: 20px;
                width: 700px;
                margin: 40px auto;
                border-radius: 10px;
                box-sizing: border-box;
                box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.23), 0 6px 20px 0 rgba(0, 0, 0, 0.22);

            }

            .form-title {
                margin-bottom: 30px;
                font-size: 20px;
                text-align: center;
            }

            .img {
                width: 300px;
                flex-shrink: 0;
                margin-right: 20px;
            }

            .el-image {
                border: 1px solid #ec0b29;
                border-radius: 6px;
            }

            .con {
                flex: 1;
                margin-left: 10px;
            }
        }
    }

    .travel-title {
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        margin: 80px 0;
        color: #222;
        border-top: 1px solid #eee;
        padding-top: 40px;
    }

    .travel-lists {
        max-width: 1200px;
        margin: 80px auto 100px;
        display: flex;
        flex-wrap: wrap;

        .list {
            background-color: #f0f0f0;
            width: calc(25% - 20px);
            margin-right: 25px;
            padding: 5px;
            box-sizing: border-box;
            border-radius: 5px;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 30px;
            border: 1px solid #ddd;

            &:nth-of-type(4n) {
                margin-right: 0;
            }

            .img {
                width: 100%;
                height: 350px;
                overflow: hidden;
                display: flex;
                align-items: start;
                justify-content: center;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center top;
                    transition: .3s all;
                }
            }

            .title {
                font-size: 16px;
                font-weight: 700;
                color: #000;
                padding: 10px;
                box-sizing: border-box;
                height: 60px;
                transition: .3s all;
            }

            .btn {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #ec0b29;
                color: #fff;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
                width: 100px;
                height: 30px;
                box-sizing: border-box;
                float: right;
                margin-top: 10px;
                border-radius: 4px;
                margin-right: 10px;
                margin-bottom: 6px;
                transition: .3s all;
            }

            &:hover {
                box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.23), 0 6px 20px 0 rgba(0, 0, 0, 0.22);

                .img img {
                    transform: scale(1.1);
                }

                .title {
                    color: #ec0b29;
                }
            }
        }
    }

    .el-pagination {
        margin: 50px auto 120px;
        display: flex;
        justify-self: center;
    }

    :deep(.el-pagination.is-background .el-pager li.is-active) {
        background-color: #ec0b29;
    }

    :deep(.el-pager li:hover) {
        color: #ec0b29;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/toursDetail.vue